<!-- Category Picker Builder -->

<template>
	<div class="bld-cat-pick-btn-main">
		<div class="title wi8_font">Category Picker Button Builder (cat: {{current.title}})</div>

		<CatPickBtn />

	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	computed: {
		...mapState('app', ['current']),
	},
}
</script>

<style scoped>
	.bld-cat-pick-btn-main {
		height: 100%;
		overflow: hidden;
		background-color: #FCFCDD;
		padding: 5px;
		border: solid 0px #009;
	}
	.title {
		color: #090;
	}
</style>
